module.exports = __webpack_public_path__ + "img/5.6bec96b4.png";